import React from 'react'
import QuoteIcon from '../../../images/quote.svg'
import AboutSchemeMobileIcon from '../../../images/about-scheme-mobile.svg'
import AboutSchemeIcon from '../../../images/about-scheme.svg'

export const About: React.FC = () => {
  const [isMobileVersion, setMobileVersion] = React.useState<boolean>()
  const handleMobileVersion = () => {
    setMobileVersion(!!window.matchMedia('(max-width: 768px)').matches)
  }
  React.useEffect(() => {
    setMobileVersion(!!window.matchMedia('(max-width: 768px)').matches)
    window.addEventListener('resize', handleMobileVersion)
    return () => {
      window.removeEventListener('resize', handleMobileVersion)
    }
  })
  const blocks = getBlocks()
  return (
    <div className='onlinepbx__head'>
      <div className='onlinepbx__container'>
        <div className='onlinepbx__about__content'>
          <h2 className='onlinepbx__content__header__center onlinepbx__about__header'>О компании</h2>
          <div className='onlinepbx__about__text'>
            Лидером и&nbsp;идейным вдохновителем компании остаётся Вячеслав Чукреев&nbsp;&mdash; основатель компании. Всё началось в&nbsp;декабре
            2009&nbsp;года, когда у&nbsp;Вячеслава родился старший сын и&nbsp;тогда&nbsp;же появился на&nbsp;свет сервис{' '}
            <span className='onlinepbx__about__text__bold__green'>online</span>
            <span className='onlinepbx__about__text__bold'>PBX</span>.
          </div>
          <div className='onlinepbx__about__quote'>
            <QuoteIcon className='onlinepbx__about__quote__icon' />
            <div className='onlinepbx__about__quote__text'>
              <div className='onlinepbx__about__quote__delta' />
              Идея пришла, когда я&nbsp;устанавливал в&nbsp;офисы мини-АТС. В&nbsp;то&nbsp;время было бурное развитие высокоскоростного интернета
              и&nbsp;IP-телефонии. Я&nbsp;увидел в&nbsp;этом много возможностей.
            </div>
            <div className='onlinepbx__about__quote__photo'>
              {(isMobileVersion && <img src={process.env.PUBLIC_DIR + '/images/Slavyan-mini.png'} alt='' />) || (
                <img src={process.env.PUBLIC_DIR + '/images/Slavyan.png'} alt='' />
              )}
              <div className='onlinepbx__about__quote__photo__person'>
                <div className='onlinepbx__about__quote__photo__name'>Вячеслав Чукреев,</div>
                <div className='onlinepbx__about__quote__photo__surname'>основатель компании</div>
              </div>
            </div>
          </div>
          {blocks.map((block) => block.text)}
        </div>
        <div className='onlinepbx__about__steps'>
          <h3>Ключевые этапы развития</h3>
          {(isMobileVersion && <AboutSchemeMobileIcon className='onlinepbx__about__steps__scheme' />) || (
            <AboutSchemeIcon className='onlinepbx__about__steps__scheme' />
          )}
        </div>
      </div>
    </div>
  )
}

const getBlocks = () => {
  return [
    {
      text: (
        <div key='0' className='onlinepbx__about__text'>
          Первых клиентов Вячеслав нашёл сам: обзвонил 40&nbsp;компаний в&nbsp;одном офисном здании, а&nbsp;контакты нашёл через всем известный
          онлайн-справочник. Так появились первые три клиента, которым был продан сервис. А&nbsp;потом Вячеслав начал думать, как этот сервис
          реализовать. Пять лет мы&nbsp;разрабатывали, тестировали, внедряли, подключали партнеров, прислушивались к&nbsp;обратной связи
          и&nbsp;совершенствовали сервис.
        </div>
      )
    },
    {
      text: (
        <div key='1' className='onlinepbx__about__text'>
          <span className='onlinepbx__about__text__bold'>С&nbsp;2013 по&nbsp;2016 года </span> был активный рост: выпустили коллбек-виджет, первыми
          создали интеграцию с&nbsp;amoCRM и&nbsp;подключили первую тысячу пользователей.
        </div>
      )
    },
    {
      text: (
        <div key='2' className='onlinepbx__about__text'>
          <span className='onlinepbx__about__text__bold'>После 2016&nbsp;года</span>, когда стартап окреп и&nbsp;стал бизнесом, определили миссию
          компании и&nbsp;сформировали первый двухлетний план развития.
        </div>
      )
    },
    {
      text: (
        <div key='3' className='onlinepbx__about__text'>
          <span className='onlinepbx__about__text__bold'>В&nbsp;апреле 2018</span> переписали сервис используя новые технологии, разработали мобильное
          приложение и&nbsp;обновили коллбек-виджет с&nbsp;возможностью звонить через сайт.
        </div>
      )
    },
    {
      text: (
        <div key='4' className='onlinepbx__about__text'>
          <span className='onlinepbx__about__text__bold'>В&nbsp;2019 году</span> сосредоточились на&nbsp;росте и&nbsp;формализации внутренних бизнес-процессов. Работа дала свои плоды&nbsp;&mdash; количество подключенных пользователей превысила отметку в&nbsp;<span className='onlinepbx__about__text__bold__green'>&nbsp;22000</span>.
        </div>
      )
    }
  ]
}

export default About
